import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import { Button, Groupper, Input, Message } from 'react-frontier';
import { useBreadcrumbs } from '../Hooks';
import { TIMEZONE, todayInput, inputToUnix } from '../SiteUtil';
import API from '../API';

var PromotersReport = ()=>{
	var { setTitle } = useBreadcrumbs();
	var [dateStart, setDateStart] = useState<string>(DateTime.now().setZone(TIMEZONE).minus({ days: 30 }).toFormat('yyyy-MM-dd'));
	var [dateEnd, setDateEnd] = useState<string>(todayInput());
	var [prompts, setPrompts] = useState<string[]>(null);

	useEffect(()=>{
		setTitle('Reporte promotores');
	}, []);

	var download = (setLoading: (l: boolean)=>void)=>{
		setPrompts(null);
		var start = inputToUnix(dateStart);
		var end = inputToUnix(dateEnd);
		if(start===null || end===null) return setPrompts(['Selecciona fechas válidas.']);
		if(start > end) return setPrompts(['La fecha de inicio no puede ser mayor a la fecha de fin.']);

		setLoading(true);
		API.downloadPromotersReport(start, end + 86399).then(res=>{
			if(res && res.error) setPrompts([res.message || 'Hubo un error descargando el reporte. (LCL-RPTP-1)']);
		}).catch(()=>{
			setPrompts(['Hubo un error descargando el reporte. (LCL-RPTP-1)']);
		}).finally(()=>setLoading(false));
	};

	return <div style={{ marginTop: 20 }}>
		<Groupper title='Reporte promotores' titleCentered actions={
			<Button text='Descargar' iconName='download' color='black' onClick={download} />
		} style={{ maxWidth: 400, margin: 'auto' }}>
			<div style={{ display: 'flex', gap: 12 }}>
				<Input label='Fecha inicio' inputType='date' value={dateStart} onChange={setDateStart} style={{ margin: 0, flex: 1 }} />
				<Input label='Fecha fin' inputType='date' value={dateEnd} onChange={setDateEnd} style={{ margin: 0, flex: 1 }} />
			</div>
			<Message type='error' list={prompts} style={{ marginTop: 12 }} />
		</Groupper>
	</div>;
}

export default PromotersReport;
